import { render, staticRenderFns } from "./FinishingsDetail.vue?vue&type=template&id=6549c5ba"
import script from "./FinishingsDetail.vue?vue&type=script&lang=js"
export * from "./FinishingsDetail.vue?vue&type=script&lang=js"
import style0 from "./FinishingsDetail.vue?vue&type=style&index=0&id=6549c5ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports